import popup from './popup';

export default { popup };
